// extracted by mini-css-extract-plugin
module.exports = {"spotlight":"styles_spotlight__nrQiz","spotlight-mobile":"styles_spotlight-mobile__BNCFV"};